export default {
  items: [],
  pagination: {},
  isBusy: false,
  filter: {},
};
